import { DetailEditorPropsByYear } from '../types'
import { CashCropEditor } from './CashCropEditor'

export const CashCropEditorSimple = (props: DetailEditorPropsByYear) => (
  <CashCropEditor {...props} simple />
)
